<template #default="{}">
  <div v-show="deliverableDetail" tabindex="-1" @keyup.esc.stop="escapeListener" ref="rootTag">
    <div id="social-modal-overlay">
      <div class="top" ref="overlayTop"></div>
      <div class="right" ref="overlayRight"></div>
      <div class="bottom" ref="overlayBottom"></div>
      <div class="left" ref="overlayLeft"></div>
    </div>
    <b-modal v-model="showSeriesManualUpdate" type="warn" title="Override Master Post?"
      @hide="seriesModalHidden($event)">
      <p>This post will no longer be automatically updated by changes to the master post. Do you want to proceed?</p>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="success" @click="clickSeriesModalUpdate" :disabled="seriesManualUpdateDisabled">
          Edit Separately From Master
        </b-button>
        <b-button size="sm" variant="danger" @click="clickSeriesModalCancel" :disabled="seriesManualUpdateDisabled">
          Cancel
        </b-button>
        <b-button size="sm" variant="secondary" @click="clickSeriesModalViewMaster"
          :disabled="seriesManualUpdateDisabled">
          Edit Master
        </b-button>
      </template>
    </b-modal>
    <b-modal v-model="showSeriesRejoinMaster" type="warn" title="Rejoin Master Post">
      <p>Content for this post will be pulled from the master post, and any content or comments specific to this post
        will be lost. Do you want to proceed?</p>
      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="success" @click="clickConfirmRejoinMaster" :disabled="seriesRejoinMasterDisabled">
          Rejoin Master
        </b-button>
        <b-button size="sm" variant="danger" @click="clickCancelRejoinMaster" :disabled="seriesRejoinMasterDisabled">
          Cancel
        </b-button>
      </template>
    </b-modal>
    <b-modal v-model="showRemoveDeliverable" type="warn" title="Confirm Deletion" @ok="onConfirmRemoveDeliverable"
      ok-title="Yes, Delete">
      <p>Are you sure you want to delete this deliverable?</p>
    </b-modal>
    <div :class="socialModalClass">
      <b-tabs content-class="mt-3" class="social-modal-tabs" v-model="currentTab" ref="socialModalTabs">
        <b-tab title="Editor" active ref="tabEditor" title-item-class="tabEditorTitle">
          <template #title>
            <span class="nav-item-label">Editor</span>
          </template>
          <section class="breadcrumbs-section">
            <BreadCrumbs :breadcrumbs="breadcrumbs" :namespace="namespace" />
          </section>
          <section class="settings campaign-settings" v-if="getSystemSetting('social_media___enable_social_campaign')">
            <div class="settings-header">

              <b-button v-b-toggle.collapse-social-campaign-dialog class="campaign-group-toggle">
                <i class="fas fa-chevron-right collapse-indicator"></i>
              </b-button>
              <SocialDeliverableCampaigns :key="`sdc-`+deliverableDetail.id" :deliverable="deliverableDetail"
                :disabled="showSocialCampaignSettings"
                @click-title="showSocialCampaignSettings = !showSocialCampaignSettings" :namespace="namespace" />
              <SocialCampaignTitle :deliverable="deliverableDetail" :disabled="!showSocialCampaignSettings"
                :namespace="namespace" />

              <div v-if="isSocialCampaign && campaignDetailExists && 1 == 2">
                <b-button v-if="!showSocialCampaignSettings" v-b-toggle.collapse-social-campaign-dialog>Show
                  Campaign</b-button>
                <b-button v-if="showSocialCampaignSettings" v-b-toggle.collapse-social-campaign-dialog>Hide
                  Campaign</b-button>
              </div>
            </div>
            <b-collapse v-if="isSocialCampaign && campaignDetailExists" v-model="showSocialCampaignSettings"
              id="collapse-social-campaign-dialog" class="settings-content-collapse">
              <div class="settings-content">
                <SocialCampaignDialog :hideTitle="true" :hideDelete="true" :namespace="namespace" />
              </div>
            </b-collapse>
          </section>
          <section class="settings series-settings" v-if="isSocialSeries && seriesFetched && 1 == 2">
            <div class="settings-header">

              <b-button v-b-toggle.collapse-social-series-dialog class="campaign-group-toggle">
                <i class="fas fa-chevron-right collapse-indicator"></i>
              </b-button>
              <SocialSeriesTitle :deliverable="socialSeriesDetail" :disabled="!showSocialSeriesSettings"
                :namespace="namespace" />
              <div class="pb-0 group-title-wrapper" v-show="!showSocialSeriesSettings"
                @click="showSocialSeriesSettings = !showSocialSeriesSettings">
                <div class="type-label">Series</div>
                <div class="group-title">
                  <div class="group-title">
                    <h1 class="mb-0 exclude-outside-click project-title" v-show="!editTitle">{{ socialSeriesDetail.title
                      }}</h1>
                  </div>
                </div>
              </div>


              <div class="settings-header-buttons" v-if="false">
                <b-button v-if="!showSocialSeriesSettings" v-b-toggle.collapse-social-series-dialog>Show
                  Series</b-button>
                <b-button v-if="showSocialSeriesSettings" v-b-toggle.collapse-social-series-dialog>Hide
                  Series</b-button>
              </div>
            </div>
            <b-collapse v-model="showSocialSeriesSettings" id="collapse-social-series-dialog"
              class="settings-content-collapse">
              <div class="settings-content">
                <SocialSeriesDialog :hideTitle="true" :namespace="namespace" />
              </div>
            </b-collapse>
          </section>
          <section class="post-editor-section">
            <div class="details header">
              <div class="row">
                <div class="col-sm-6 col-md-8">
                  <label v-if="isMobile()" class="form-group w-100 sticky__delv__title">
                    <h2 @click="activateTitleField" class="exclude-outside-click edit-d-title deliverable-title"
                      v-show="!editTitle">{{ deliverableDetail.title || 'Click to set...' }}</h2>
                    <textarea v-click-outside="outside" ref="deliverableTitle" v-show="editTitle"
                      v-model="deliverableDetail.title" type="text" :placeholder="getDeliverableTitlePlaceholder"
                      class="form-control mb-3 title-field exclude-outside-click h2" @change="onUpdateDeliverableTitle"
                      @blur="editTitle=false;"></textarea>
                  </label>
                  <div class="row">
                    <div class="col">
                      <label v-if="!isMobile()" class="form-group mb-0 w-100">
                        <h2 @click="activateTitleField" class="exclude-outside-click edit-d-title deliverable-title"
                          v-show="!editTitle">{{ deliverableDetail.title || 'Click to set...' }}</h2>
                        <textarea v-click-outside="outside" ref="deliverableTitle" v-show="editTitle"
                          v-model="deliverableDetail.title" type="text" :placeholder="getDeliverableTitlePlaceholder"
                          class="form-control mb-3 title-field exclude-outside-click h2"
                          @change="onUpdateDeliverableTitle" @blur="editTitle=false;"></textarea>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-4">
                  <SocialStatusLabel :deliverable="deliverableDetail" :namespace="namespace" />
                </div>
              </div>
            </div>
            <!-- BEGIN Platforms/Language section -->
            <div class="details bubble">
              <div class="row social-settings-row">
                <div class="col-md-6">
                  <h3>Languages</h3>
                  <div class="social-settings-group">
                    <fieldset class="lang social-settings">
                      <b-form-checkbox-group v-model="selectedLanguages" :options="checkboxLanguageOptions"
                        name="languages" @change="selectedLanguagesUpdated"
                        :disabled="languagesDisabled"></b-form-checkbox-group>
                    </fieldset>
                  </div>
                </div>
                <div class="col-md-6">
                  <h3>Platforms</h3>
                  <div class="social-settings-group">
                    <fieldset class="network social-settings">
                      <b-form-checkbox-group v-model="selectedSocialNetworks" :options="checkboxSocialNetworkOptions"
                        name="social-networks" @change="selectedSocialNetworksUpdated"
                        :disabled="socialNetworksDisabled"></b-form-checkbox-group>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
            <!-- END Platforms/Language section -->
            <div class="details bubble mb-0">
              <div v-if="isSocialSeriesMaster(deliverableDetail.id)" class="social-date-picker-wrap series">
                <h3 class="posting-dates-title">Posting Dates & Times</h3>
                <div :class="`series-post${seriesPostClass(seriesDeliverable)}`"
                  v-for="seriesDeliverable in deliverableDetail.social_series_deliverables"
                  v-if="!isSocialSeriesMaster(seriesDeliverable.id)"
                  :key="'series-post-'+seriesDeliverable.id+'-'+refreshKey">
                  <SocialSeriesStatusBar :deliverable="seriesDeliverable" :namespace="namespace" />
                  <SocialDatePicker :key="`'socialdatepicker'+deliverableDetail.id+'-'+refreshKey`"
                    :deliverableId="seriesDeliverable.id" :publishDate="seriesDeliverable.publish_date"
                    :seriesDeliverables="deliverableDetail.social_series_deliverables" :namespace="namespace" />
                  <SocialStatusLabel :deliverable="seriesDeliverable" :namespace="namespace" />
                </div>
                <div class="new-series-post">
                  <b-modal id="seriesAddMultipleDates" title="Add Multiple Dates" size="lg" hide-footer>
                    <SocialMultiDatePicker :key="`'socialdatepickermulti'+deliverableDetail.id+'-'+refreshKey`"
                      :seriesId="deliverableDetail.social_series[0]"
                      :latestPost="deliverableDetail.social_series_deliverables.at(-1)"
                      :seriesDeliverables="deliverableDetail.social_series_deliverables" :namespace="namespace" />
                  </b-modal>
                  <b-button variant="theme" @click="clickSeriesAddMultipleDates">Add Multiple Dates</b-button>
                </div>
              </div>
              <div v-else-if="isSocialSeries" class="social-date-picker-wrap single-post">
                <h3>Posting Date & Time</h3>

                <SocialDatePicker :key="'socialdatepicker'+deliverableDetail.id+'-'+refreshKey"
                  :deliverableId="deliverableDetail.id" :publishDate="deliverableDetail.publish_date"
                  :seriesDeliverables="deliverableDetail.social_series_deliverables" :namespace="namespace" />
                <b-button @click="clickSeriesModalViewMaster">Edit Master Post</b-button>
                <b-button @click="clickSeriesRejoinMaster">Rejoin Master Post</b-button>
              </div>
              <div v-else class="social-date-picker" :id="'socialdatepicker-wrapper'+deliverableDetail.id">
                <h3>Posting Date & Time</h3>
                <SocialDatePicker :deliverableId="deliverableDetail.id"
                  :key="'socialdatepicker'+deliverableDetail.id+'-'+refreshKey"
                  :publishDate="deliverableDetail.publish_date" :namespace="namespace" />
                <b-button :class="'btn-theme'" @click="createSocialSeriesFromDeliverable"
                  v-if="getSystemSetting('social_media___enable_social_series')">Enable Multiple Dates</b-button>
              </div>

            </div>

            <div class="details post-editor" ref="refPostEditor">
              <div class="post-editor-wrap">
                <div class="post-editor-language" v-for="language in deliverableDetail.languages">
                  <div :class="`language-${ languages.find(lang => lang.id == language).lang_code }`">
                    <SocialPostEditor v-for="socialPost in deliverableDetail.social_posts" :key="socialPost.id"
                      :lang="systemSettings.languages.find(lang => lang.id == language)" :post="socialPost"
                      :namespace="namespace" />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="tasks-section" :class="{ 'disabled': isPublishedPost }">
            <div class="form-group">
              <div class="tags__wrapper">
                <DeliverableListTags :deliverable="deliverableDetail" :namespace="namespace" />
              </div>
            </div>
            <div class="details brief-editor">
              <h3>Notes</h3>
              <ckeditor v-if="deliverableDetail.deliverableId"
                editorUrl="/js/ckeditor/ckeditor.js" v-model="description"
                :id="'deliverable-description-'+deliverableDetail.deliverableId" :config="editorConfig"
                @blur="deliverableDescriptionUpdated" :editorDisabled="descriptionDisabled"></ckeditor>
            </div>
            <div class="row">
              <div class="col-md-12" ref="refTaskFieldsWrapper">
                <div class="add-task-button-mobile">
                  <b-button v-if="canCreateTask()" variant="theme" class="add-task-btn" @click.stop="createTask">
                    Add Task
                    <div role="status" v-show="addingTask" class="ml-2 spinner-border spinner-border-sm text-primary">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </b-button>
                </div>
                <TaskFieldLabels ref="TaskFieldLabelsRef" :fullDeliverables="deliverableDetail"
                  :deliverableId="deliverableDetail.deliverableId" :deliverable="deliverableDetail"
                  :tasks="deliverableDetail.tasks" :namespace="namespace" />
                <TaskFields :fullDeliverables="deliverableDetail" :deliverableId="deliverableDetail.deliverableId"
                  :deliverable="deliverableDetail" :tasks="deliverableDetail.tasks" :namespace="namespace" />
                <span class="below-tasks" ref="refBelowTasks"></span>
              </div>
            </div>
          </section>
          <section class="footer-controls-section">
            <button v-b-tooltip.hover :title="getDeleteDeliverableTitle"
              @click="removeDeliverable(deliverableDetail.deliverableId)" class="btn delete-deliverable-btn"
              v-if="userAbilities.deleteMediaCall && deliverableDetail.permissions && !deliverableDetail.permissions.viewOnly && !isPublishedPost">
              <i class="fas fa-trash-alt"></i>
            </button>
          </section>
        </b-tab>
        <b-tab title="Comments" ref="tabComments" title-item-class="tabCommentsTitle">
          <template #title>
            <span class="nav-item-label">Comments</span>
          </template>
          <section class="breadcrumbs-section">
            <BreadCrumbs :breadcrumbs="breadcrumbs" :namespace="namespace" />
          </section>
          <section class="comments-section">
            <div class="language-group" v-for="language in deliverableDetail.languages">
              <h2 class="lang-title">{{systemSettings.languages.find(lang => lang.id == language).lang_name}}</h2>
              <div class="post-group" v-for="social_post in deliverableDetail.social_posts"
                v-if="social_post.lang_id == language">
                <b-button v-b-toggle="`comments-toggle-${social_post.id}`" class="post-group-toggle">
                  <i class="fas fa-chevron-right collapse-indicator"></i>
                  <i v-for="network in social_post.social_networks"
                    :class="`fab fa-${getSocialNetworkClassFromId(network)} platform-indicator`"
                    :title="getSocialNetworkNameFromId(network)"></i>
                  <span class="comment-count">
                    ({{ displayPostCommentCount(social_post) }})
                  </span>
                </b-button>
                <b-collapse visible :id="`comments-toggle-${social_post.id}`">
                  <div class="platform-group-content">
                    <div class="details post-image-details">
                      <div class="row">
                        <div class="col-md-6">
                          <span class="no-images" v-if="!social_post.files.length">No images.</span>
                          <div class="image-group" v-else>
                            <SocialPostImageSlider :socialPost="social_post" location="comments"
                              :namespace="namespace" />
                          </div>
                        </div>
                        <div class="col-md-6 comments-col">
                          <SocialPostCommentEditor :socialPost="social_post" :commentField="`image`"
                            :key="'social-post-'+social_post.id+'-comments-image'" :namespace="namespace" />
                        </div>
                      </div>
                    </div>
                    <div class="details post-caption-details">
                      <div class="row">
                        <div class="col-md-6">
                          <span class="no-caption" v-if="!social_post.caption">No post copy.</span>
                          <div class="caption-wrap">
                            {{ social_post.caption }}
                          </div>
                        </div>
                        <div class="col-md-6 comments-col">
                          <SocialPostCommentEditor :socialPost="social_post" :commentField="`caption`"
                            :key="'social-post-'+social_post.id+'-comments-caption'" :namespace="namespace" />
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
          </section>
        </b-tab>
        <b-tab title="Summary" class="tab-pane__summary" ref="tabSummary" title-item-class="tabSummaryTitle">
          <template #title>
            <span class="nav-item-label">Summary</span>
          </template>
          <section class="breadcrumbs-section">
            <BreadCrumbs :breadcrumbs="breadcrumbs" :namespace="namespace" />
          </section>
          <section class="settings series-settings"
            v-if="isSocialSeries && seriesFetched && !deliverableDetail.is_master">
            <div class="settings-header">
              <div class="settings-header-title">
                <div class="department-label">Series:</div>
                <div class="department-title">{{socialSeriesDetail.title}}</div>
              </div>
              <div class="settings-header-buttons">
                <b-button @click="clickSeriesModalViewMaster">View Master Post</b-button>
              </div>
            </div>
          </section>
          <section class="summary-languages">
            <div v-for="language in deliverableDetail.languages" class="summary-language">
              <div class="summary-post" v-for="social_post in deliverableDetail.social_posts"
                v-if="social_post.lang_id == language">
                <div class="summary-post-header">
                  <h3 class="language-heading">{{systemSettings.languages.find(lang => lang.id == language).lang_name}}
                  </h3>
                  <div class="platforms">
                    <h4>
                      <i v-for="network in social_post.social_networks"
                        :class="`fab fa-${getSocialNetworkClassFromId(network)} platform-indicator`"
                        :title="getSocialNetworkNameFromId(network)"></i>
                    </h4>
                  </div>
                </div>
                <div class="summary-images social-image-slider">
                  <SocialPostImageSlider :socialPost="social_post" location="summary" :namespace="namespace" />
                </div>
                <div class="summary-caption">
                  <div class="caption-text">
                    <span class="no-caption" v-if="!social_post.caption">No post copy.</span>
                    <div class="caption-wrap" v-if="social_post.caption">
                      <span v-html="formatCaptionText(social_post.caption)"></span>
                      <button @click="copyFn(social_post.caption, social_post.id)"
                        :id="`copy-post-btn-${social_post.id}`" class="btn btn-text btn-copy" type="button"
                        data-dismiss="modal"><i :class="getCopyIconClass(social_post.id)"></i></button>
                      <b-tooltip :target="`copy-post-btn-${social_post.id}`" triggers="hover"
                        noninteractive>{{ getCopyTooltipText(social_post.id) }}</b-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section class="summary-images" v-if="hasFilesToDownload">
            <h6 class="summary-download-images-link"
              @click="downloadImagesZip" 
              title="Download Images">Download Images
              <i class="fas fa-download"></i>
            </h6>
          </section>
          <section class="summary-schedule">
            <SocialSummarySchedule :deliverable="deliverableDetail" :namespace="namespace" />
          </section>
          <section class="summary-controls">
            <SocialSummaryControls :namespace="namespace" @task-status-updated="updateDeliverableTasks" />
          </section>
        </b-tab>
        <b-tab :title-link-class="'close-tab-link'" :title-item-class="'close-tab'" @click="onCloseModal">
          <template #title>
            <i class="fas fa-times"></i>
          </template>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Autocomplete from '@trevoreyre/autocomplete-vue';
import { mapActions, mapMutations, mapState } from "vuex";
import Format from "../../utility/Format";
import DeliverableCustomFields from "../common/DeliverableCustomField";
import FeedbackBtn from "../common/FeedbackBtn";
import FullContactField from "../common/FullContactField";
import BreadCrumbs from "./BreadCrumbs";
import DeliverableDepartments from "./DeliverableDepartments";
import DeliverableListTags from "./DeliverableListTags";
import DeliverableProjects from "./DeliverableProjects";
import UpdateContactModal from "./EditContactModal";
import TaskFieldLabels from "./TaskFieldLabels";
import TaskFields from "./TaskFields";
import toast from "../../toast";
import SocialPostCommentEditor from "./SocialPostCommentEditor.vue";
import SocialPostInfo from "./SocialPostInfo.vue";
import SocialDatePicker from "./SocialDatePicker.vue";
import SocialMultiDatePicker from "./SocialMultiDatePicker.vue";
import SocialPostEditor from "./SocialPostEditor.vue";
import SocialPostImageSlider from "./SocialPostImageSlider.vue";
import SocialStatusLabel from "./SocialStatusLabel.vue";
import SocialSummaryControls from "./SocialSummaryControls.vue";
import SocialSummaryPost from "./SocialSummaryPost.vue";
import SocialSummarySchedule from "./SocialSummarySchedule.vue";
import Autolinker from 'autolinker';
import SocialCampaignDialog from "./SocialCampaignDialog.vue";
import SocialCampaignTitle from "./SocialCampaignTitle.vue";
import SocialSeriesDialog from "./SocialSeriesDialog.vue";
import SocialSeriesStatusBar from "./SocialSeriesStatusBar.vue";
import SocialSeriesTitle from "./SocialSeriesTitle.vue";
import SocialDeliverableCampaigns from "./SocialDeliverableCampaigns.vue";


export default {
  data() {
    return {
    	showBriefEditor:false,
      Format,
      title: "",
      description: "",
      descriptionDisabled: false,
      postDate: "",
      postTime: "",
      dateTimeDisabled: false,
      dateFormat: "MMMM Do YYYY, h:mm a",
      addingTask: true,
      showModalOptions: false,
      renderCount: 1,
      newContactId: "",
      newContactName: "",
      editTitle: false,
      originalTitle:null,
      addContactFlag: false,
      addWhoFlag:false,
      addSpokespersonFlag:false,
      showRemoveDeliverable: false,
      showRemoveContact:false,
      showRemoveSpokesperson:false,
      showRemoveWho:false,
      contacts:[],
      postImages: [],
      selectedLanguages: [],
      selectedSocialNetworks: [],
      languagesDisabled: false,
      socialNetworksDisabled: false,
      carouselInterval: 3000,
      showNewDateTime: false,
      showSeriesManualUpdate: false,
      showSeriesRejoinMaster: false,
      seriesManualUpdateDisabled: false,
      seriesRejoinMasterDisabled: false,
      showSocialCampaignSettings: false,
      showSocialSeriesSettings: false,
      contentDiv: null,
      currentTab: 0,
      copyStates: {},
      copySuccessTimeout: null,
      overlayInterval: null,
      editorConfig: {
        toolbar:  [
          { name: 'document', groups: [ 'mode' ], items: [ 'Source' ] },
          { name: 'clipboard', groups: [ 'clipboard', 'undo' ], items: [ 'Cut', 'Copy', 'Paste', 'PasteText', '-', 'Undo', 'Redo' ] },
          { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ], items: [ 'Bold', 'Italic', 'Underline', '-', 'RemoveFormat' ] },
          { name: 'paragraph', groups: [ 'list', 'blocks', 'align' ], items: [ 'NumberedList', 'BulletedList', 'Blockquote', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
          { name: 'links', items: [ 'Link', 'Unlink' ] },
          { name: 'insert', items: [ 'Image', 'Table', 'HorizontalRule' ] },
          { name: 'styles', items: [ 'Styles' ] },
          { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
          { name: 'tools', items: [ 'Maximize' ] }
        ],
      }
    };
  },
  components: {
    BreadCrumbs,
    DeliverableProjects,
    DeliverableCustomFields,
    TaskFields,
    TaskFieldLabels,
    UpdateContactModal,
    DeliverableListTags,
    DeliverableDepartments,
    FullContactField,
    Autocomplete,
    FeedbackBtn,
    SocialPostInfo,
    SocialPostCommentEditor,
    SocialPostImageSlider,
    SocialPostEditor,
    SocialSummaryControls,
    SocialSummaryPost,
    SocialSummarySchedule,
    SocialStatusLabel,
    SocialDatePicker,
    SocialMultiDatePicker,
    SocialSeriesStatusBar,
    SocialSeriesDialog,
    SocialCampaignDialog,
    SocialCampaignTitle,
    SocialSeriesTitle,
    SocialDeliverableCampaigns
  },
  props: ["allContacts", "modalId", "tabIndex", "namespace"],

  computed: {
  	...mapState({
    state (state) {
      return state[this.namespace]
    },
    getSocialNetworkClass(state, getters) {
      return getters['getSocialNetworkClass']
    },

    allDepartments (state, getters) {
    	return getters[this.namespace + 'allDepartments']
    },
    allSubjects (state, getters) {
    	return getters[this.namespace + 'allSubjects']
    },
    deliverableDetail (state, getters) {
    	return getters[this.namespace + 'deliverableDetail']
    },
    allTags (state, getters) {
    	return getters[this.namespace + 'allTags']
    },
    allRegions (state, getters) {
    	return getters[this.namespace + 'allRegions']
    },
    deliverableContactsLabel (state, getters) {
    	return getters[this.namespace + 'deliverableContactsLabel']
    },
    allCustomFields (state, getters) {
    	return getters[this.namespace + 'allCustomFields']
    },
    initialContacts (state, getters) {
    	return getters[this.namespace + 'initialContacts']
    },
    userAbilities (state, getters) {
    	return getters['userAbilities']
    },
    deliverableTypes (state, getters) {
    	return getters[this.namespace + 'deliverableTypes']
    },
    allCustomFields (state, getters) {
    	return getters[this.namespace + 'allCustomFields']
    },
    systemSettings (state, getters) {
    	return getters['systemSettings']
    },
    socialSeriesDetail (state, getters) {
    	return getters[this.namespace + 'socialSeriesDetail']
    },
    socialCampaignDetail (state, getters) {
    	return getters[this.namespace + 'socialCampaignDetail']
    },
    getSystemSetting (state, getters) {
    	return getters[this.namespace + 'getSystemSetting']
    },
    refreshKey (state, getters) {
    	return getters[this.namespace + 'refreshKey']
    },
    openWithFocus (state, getters) {
    	return getters[this.namespace + 'openWithFocus']
    },
    getDeliverableTemplateSlug(state, getters) {
				return getters[this.namespace + "getDeliverableTemplateSlug"];
		},
      breadcrumbs(state, getters) {
        return getters[this.namespace + 'breadcrumbs']
      },
  }),
    console: () => console,
    // so that we can use lodash in the template
    _() {
      return _;
    },
    checkboxLanguageOptions(){
      let languageOptions = [];
      if (this.systemSettings.languages){
        this.systemSettings.languages.forEach(function(lang){
          languageOptions.push({
            html: lang.lang_code,
            value: lang.id,
            title: lang.lang_name,
          });
        })
      }
      return languageOptions;
    },
    languages(){
      let computedLanguages = [];
      if(this.systemSettings.languages){
        computedLanguages = this.systemSettings.languages;
      }
      return computedLanguages;
    },
    checkboxSocialNetworkOptions(){
    	let that = this;
      let socialNetworkOptions = [];

      if(this.systemSettings.social_networks && this.systemSettings.social_network_clients){
        this.systemSettings.social_networks.forEach(function(network){
        	that.systemSettings.social_network_clients.forEach(function(client){
        		if (network.id == client.social_network_id && client.client_id == that.deliverableDetail.client_id && client.is_enabled == 1) {
		        	// only show the entry if there are accounts for the
              socialNetworkOptions.push({
                html: "<i class='fab fa-"
                  + that.getSocialNetworkClass(network.api_type)
                  + "' title='" + that.getSocialNetworkNameFromId(network.id)
                  + " '></i>",
                value: network.id,
              });
	        	}
        	});
        })
      }
      return socialNetworkOptions;
    },
    networks(){
      let computedNetworks = [];
      if(this.systemSettings.social_networks){
        computedNetworks = this.systemSettings.social_networks;
      }
      return computedNetworks;
    },
    isPublishedPost() {
      let publishStatus = JSON.parse(this.deliverableDetail.publish_status);
      return publishStatus.slug === 'published';
    },
    socialModalClass(){
      let modalClass = "edit-social-deliverable-modal";
      if (this.deliverableDetail) {
	      if(this.isSocialSeriesMaster(this.deliverableDetail.id)){
	        modalClass = modalClass + " master-deliverable";
	      }
    	}
      return modalClass
    },
    getDeliverableTitlePlaceholder() {
    	if (this.deliverableDetail) {
        const deliverableTypeObj = this.deliverableTypes.find(x => x.typeId == this.deliverableDetail.deliverable_template_id);
        const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
        if (deliverableTemplateSlug == "media-call") {
	    		return "Media call title...";
	    	} else {
          if (deliverableTypeObj) {
            return deliverableTypeObj.name + " title...";
          } else {
            return "Deliverable title...";
          }
	    	}
	    }
    },

    getDeleteDeliverableTitle() {
    	if (this.deliverableDetail) {

        const deliverableTypeObj = this.deliverableTypes.find(x => x.typeId == this.deliverableDetail.deliverable_template_id);
        const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
        if (deliverableTemplateSlug == "media-call") {
          return "Delete Media Call";
        } else {
          if (deliverableTypeObj) {
            return "Delete " + deliverableTypeObj.name;
          } else {
            return "Delete Deliverable";
          }
	    	}
	    }
    },
    token(){
      return this.$store.getters.authToken;
    },
    apiUrl() {
      return process.env.MIX_API_BASE_URL;
    },
    relatedTags() {
      let trendingTags = this.$store.state.deliverables.trendingTags,
      relatedTags = [];
      if (typeof this.deliverableDetail.tags != "undefined") {
        this.deliverableDetail.tags.forEach(deliverableTag => {
          trendingTags = _.reject(trendingTags, function(e) {
            return e.id == deliverableTag.id;
          });
        });
      }
      return trendingTags;
    },

    displayPublishDate() {
      let date = this.$moment.utc(this.deliverableDetail.publish_date).local().format(this.dateFormat);
      if(date == "Invalid date"){
        return "No date set";
      }
      return date;
    },

    isSocialSeries(){
	    	if (this.deliverableDetail) {

	    	if (this.deliverableDetail.social_series) {
		      if(this.deliverableDetail.social_series.length){
		        return true;
		      }
		    }
		  }
      return false;
    },

    seriesFetched(){
      if(Object.keys(this.socialSeriesDetail).length){
        return true;
      }
      return false;
    },

    isSocialCampaign(){
      if(this.deliverableDetail.social_campaigns){
	      if(this.deliverableDetail.social_campaigns.length){
	        return true;
	      }
	    }
      return false;
    },

    campaignDetailExists(){
      if(this.socialCampaignDetail){
        if(Object.keys(this.socialCampaignDetail).length){
          return true;
        }
      }
      return false;
    },

    isManuallyUpdated() {
      if(this.deliverableDetail.manually_updated_at != null){
        return true;
      }
      return false;
    },
    hasFilesToDownload() {
      // Check if there is any object in social_posts with a non-empty files array
      return this.deliverableDetail.social_posts.some(post => post.files.length > 0);
    }
  },
  methods: {
    ...mapActions({
    updateFieldValue (dispatch, payload) {
    	return dispatch(this.namespace + 'updateFieldValue', payload)
    },
    createTag (dispatch, payload) {
    	return dispatch(this.namespace + 'createTag', payload)
    },
    removeDeliverableContact (dispatch, payload) {
    	return dispatch(this.namespace + 'removeDeliverableContact', payload)
    },
    removeDeliverableWho (dispatch, payload) {
    	return dispatch(this.namespace + 'removeDeliverableWho', payload)
    },
    removeDeliverableSpokesperson (dispatch, payload) {
    	return dispatch(this.namespace + 'removeDeliverableSpokesperson', payload)
    },
    fetchUserManageSocialCampaigns (dispatch, payload) {
    	return dispatch(this.namespace + 'fetchUserManageSocialCampaigns', payload)
    },
    fetchSocialCampaigns (dispatch, payload) {
    	return dispatch(this.namespace + 'fetchSocialCampaigns', payload)
    },
    updateDeliverableTitle (dispatch, payload) {
    	return dispatch(this.namespace + 'updateDeliverableTitle', payload)
    },
      fetchDeliverableBreadcrumbs(dispatch, payload) {
        return dispatch(this.namespace + 'fetchDeliverableBreadcrumbs', payload)
      },
      downloadSocialPostsFiles(dispatch, payload) {
        return dispatch(this.namespace + 'downloadSocialPostsFiles', payload)
      },
    }),
    ...mapMutations({
      setDeliverable (commit, payload) {
        return commit(this.namespace + 'setDeliverable', payload)
      },
	    setDeliverableDetail (commit, payload) {
	      return commit(this.namespace + 'setDeliverableDetail', payload)
	    },
	    setCalendarDeliverable (commit, payload) {
	      return commit(this.namespace + 'setCalendarDeliverable', payload)
	    },
	    increaseRefreshKey (commit, payload) {
	      return commit(this.namespace + 'increaseRefreshKey', payload)
	    },
	    setOpenWithFocus (commit, payload) {
	      return commit(this.namespace + 'setOpenWithFocus', payload)
	    },
    }),

    canCreateTask() {
    	let flag = false;
   		 if(this.userAbilities.editMediaCall || this.deliverableDetail?.permissions) {
   		 		return !this.deliverableDetail?.permissions?.viewOnly;
   			}
    	return flag;
  	},


    onUpdateDeliverableTitle() {
    	let testTitle = Format.replaceLineBreaks(this.deliverableDetail.title, " ");
    	testTitle = testTitle.trim();
    	if (testTitle == null || testTitle == "") {
    		testTitle = this.originalTitle;
    	}
      this.deliverableDetail.title = testTitle;
      this.updateDeliverableTitle(this.deliverableDetail).then(() => {
        this.$root.$emit('socialMediaDeliverableTitleUpdated', this.deliverableDetail);
      });
    },
    activateTitleField() {
      if(!this.userAbilities.editMediaCall || this.deliverableDetail?.permissions?.viewOnly) return;
      let that = this
      this.editTitle=true;

      if (this.originalTitle == null) {
      	this.originalTitle = this.deliverableDetail.title;
      }
      setTimeout(function() {
        that.$refs.deliverableTitle.select();
      }, 100)
    },

     activateBriefField() {
      if(!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      this.showBriefEditor=true;
    },



    getParentId(obj) {
      if (obj) {
        if (obj.parent_id) {
          return obj.parent_id;
        }
      }
      return null;
    },
    outside() {
      this.editTitle = false;
      this.addContactFlag = false;
      this.addSpokespersonFlag = false;
      this.addWhoFlag = false;
    },
    showAddContact() {
      this.addContactFlag = true;
      this.$nextTick(() => {
        this.$refs.deliverableContacts.$el.focus();
      });
    },
    showAddWho() {
      if(!this.userAbilities.editMediaCall || this.deliverableDetail?.permissions?.viewOnly) return;
      this.clearFlags();
      this.addWhoFlag = true;
      this.$nextTick(() => {
        this.$refs.searchWho.$refs.input.focus();
      });
    },
    clearFlags() {
      this.addSpokespersonFlag = false;
      this.addWhoFlag = false;
    },
    showAddSpokesperson() {
      if(!this.userAbilities.editMediaCall || this.deliverableDetail?.permissions?.viewOnly) return;
      this.clearFlags();
      this.addSpokespersonFlag = true;
      this.$nextTick(() => {
        this.$refs.searchSpokesperson.$refs.input.focus();
      });
    },
    onContactSearch(input) {
      this.isLoading = true;
      this.contacts = [];
      if (input.length < 1) {
        this.isLoading = false;
      }  else {
        axios.get(process.env.MIX_API_BASE_URL + "contacts?q=" + encodeURI(input))
        .then(resp => {
          this.contacts = [];
          for(var contact of resp.data) {
            contact.name = contact.first_name +  " " + contact.last_name;
            contact.commaName = contact.last_name + ", " + contact.first_name;
            this.contacts.push(contact);
          }
          this.isLoading = false;
        })
      }
    },
    contactCustomLabel ({ name, company_name }) {
      if (company_name != null) {
        return `${name} – ${company_name}`
      } else {
        return `${name}`
      }
    },

    onSpokespersonSearch(input) {
        return new Promise((resolve, reject) => {
          input = input == false ? '' : input
          axios.get(process.env.MIX_API_BASE_URL + "activeContacts?q=" + encodeURI(input))
          .then(resp => {
            let contacts = [];
            let x = 0;
            contacts.push({id:null,label:"Create new contact <strong>"+input+"</strong>", search:input, deliverablId:this.deliverableDetail.deliverableId});
            for (x = 0 ; x < resp.data.length; x++) {
              contacts.push(resp.data[x]);
            }
            this.$store.commit('setInitialData', {contacts: contacts})
            resolve(contacts);
          })
          .catch(error => {
            reject(error)
          })
        }) 
    },
    onSpokespersonSelect(selected) {
      if (selected.id == null) {
          // add new contact..
          this.newContactId = null;
          this.createSpokesperson(selected.search, this.deliverableDetail.deliverableId);
        } else {
          this.newContactId = selected;
          this.inputAddContact('spokesperson');
        }
        this.$refs.searchSpokesperson.value = null;
        this.addSpokespersonFlag = false;
      },



      onWhoSearch(input) {
          return new Promise((resolve, reject) => {
            input = input == false ? '' : input
            axios.get(process.env.MIX_API_BASE_URL + "activeContacts?q=" + encodeURI(input))
            .then(resp => {
              let contacts = [];
              let x = 0;
              contacts.push({id:null,label:"Create new contact <strong>"+input+"</strong>", search:input, deliverablId:this.deliverableDetail.deliverableId});
              for (x = 0 ; x < resp.data.length; x++) {
                contacts.push(resp.data[x]);
              }
              this.$store.commit('setInitialData', {contacts: contacts})
              resolve(contacts);
            })
            .catch(error => {
              reject(error)
            })
          })
      },
      onWhoSelect(selected) {
        if (selected.id == null) {
          // add new contact..
          this.newContactId = null;
          this.createWho(selected.search, this.deliverableDetail.deliverableId);
        } else {
          this.newContactId = selected;
          this.inputAddContact('who');
        }
        this.$refs.searchWho.value = null;
        this.addWhoFlag = false;
      },

      customChildField(key, parent_id) {
        if (this.deliverableDetail.customFields) {
          let obj = _.filter(this.deliverableDetail.customFields, {field_key: key, parent_id:parent_id});
          if (obj.length > 0) {
            // lets add it to the
            return obj;
          } else {
            // return the global version of the custom field...
            let field = _.filter(this.allCustomFields, {field_key: key});

            if (typeof this.deliverableDetail.customFields[key] == "undefined") {
            	return null;
            } else {
	            obj = {};
	            obj.id = null;
	            obj.parent_id = this.deliverableDetail.customFields[key].id;
	            obj.deliverable_id = this.deliverableDetail.customFields[key].deliverable_id;
	            obj.editing = false;
	            obj.field_id = field[0].id;
	            obj.field_key = field[0].field_key;
	            obj.field_parent_id = field[0].parent_id;
	            obj.field_type = field[0].field_type;
	            obj.note = field[0].note;
	            obj.value = null;
	            obj.label = field[0].label;
	            obj.value_set = field[0].value_set;
	            obj.updated_at = this.deliverableDetail.customFields[key].updated_at;
	           }
	           return [obj];
          }
      }
      return [];
    },


    customChildFieldValue(key, parent_id) {
      if (this.deliverableDetail.customFields) {
        let obj = _.filter(this.deliverableDetail.customFields, {field_key: key, parent_id:parent_id});
        if (obj != null) {
	        if (obj.length > 0) {
	          return obj[0].value;
	        } else {
	          return null;
	        }
	      }
      }
      return null;
    },



    createContact(newContactName) {
      this.$store.state.newContactName = newContactName;
      this.$store.state.deliverableId = deliverableId;
      this.$store.state.currentFieldKey = 'who';
      this.$bvModal.show("createContactModal");
    },
    createSpokesperson(newContactName, deliverableId) {
      this.$store.state.newContactName = newContactName;
      this.$store.state.deliverableId = deliverableId;
      this.$store.state.currentFieldKey = 'spokesperson';
      this.$bvModal.show("createSpokespersonModal");
    },
    createWho(newContactName, deliverableId) {
      this.$store.state.newContactName = newContactName;
      this.$store.state.deliverableId = deliverableId;
      this.$store.state.currentFieldKey = 'who';
      this.$bvModal.show("createWhoModal");
    },

    updateContact(contactData, fieldKey) {
      this.$store.state.currentContactData = contactData;
      this.$store.state.currentContactId = contactData.id;
      this.$store.state.currentFieldKey = fieldKey;
      if (fieldKey == 'who') {
        this.$bvModal.show("editWhoModal");
      }
      if (fieldKey == 'spokesperson') {
        this.$bvModal.show("editSpokespersonModal");
      }
    },

    contactsNotAdded(field_key) {
      let addedContacts = _.filter(this.deliverableDetail.customFields, {
        field_key: field_key
      }),
      allContacts = this.allContacts,
      addedIds = [];

      _.forEach(addedContacts, function(n, key) {
        addedIds.push(parseInt(n.value));
      });
      let result = _.reject(allContacts, function(o) {
        return addedIds.indexOf(o.id) != -1;
      });

      return result;
    },
    inputAddContact(field_key) {
      let x = 0;
      let field_id = null;
      for(x = 0; x < this.deliverableDetail.customFields.length; x++) {
        if (this.deliverableDetail.customFields[x].field_key == field_key) {
          field_id = this.deliverableDetail.customFields[x].field_id;
          break;
        }
      }
      this.newContactId.fieldId = field_id;
      switch(field_key) {
        case "who":
        this.addDeliverableWho({contactData: this.newContactId, deliverableId: this.deliverableDetail.deliverableId});
        break;
        case "spokesperson":
        this.addDeliverableSpokesperson({contactData: this.newContactId, deliverableId: this.deliverableDetail.deliverableId});
        break;
        default:
      }
    },
    addDeliverableSpokesperson(payload) {
      this.$store.dispatch(this.namespace + "addDeliverableSpokesperson", payload);
      this.newContactId = "";
    },
    addDeliverableWho(payload) {
      this.$store.dispatch(this.namespace + "addDeliverableWho", payload);
      this.newContactId = "";
    },

    addDeliverableContact(payload) {
      this.$store.dispatch(this.namespace + "addDeliverableContact", payload);
      this.newContactId = "";
    },
    removeDeliverable(deliverableId) {
      this.showRemoveDeliverable = true;
    },
    onConfirmRemoveDeliverable() {
      if (this.deliverableDetail.deliverableId) {
        let that = this;
        this.$store.dispatch(this.namespace + "removeDeliverable", { deliverableId:this.deliverableDetail.deliverableId }).then(function() {
          let mId = "editSocialModal";
          if (that.namespace == "relatedDeliverables/") {
            mId = "editRelatedSocialModal";
          }
          that.$bvModal.hide(mId);
          // TODO: removing a deliverable should only remove it from the list, not replace entire list.
          // that.$store.commit('removeMediaCallFromList', deliverableId);
          // that.$store.dispatch('countOutlets');
          if (that.namespace == "") {
          let action = 'fetchDeliverables';
          if(
            that.$router.currentRoute.name == 'socialMedia' ||
            that.$router.currentRoute.name == 'socialMediaGrouped'
          ) {
            action = 'fetchSocialMediaDeliverablesGrouped';
          } else if(that.$router.currentRoute.name == 'socialMediaSchedule') {
            action = 'fetchCalendarDeliverables';
          }
          that.$store.dispatch(that.namespace + action).then(function() {
            toast.hide();
            that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Deliverable deleted.');
          });
        } else{
          toast.hide();
          that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Deliverable deleted.');
        }
        });
      }
    },
    showRemoveDeliverableContact(contactId) {
      this.contactId = contactId;
      this.showRemoveContact = true;
    },
    onConfirmRemoveContact() {
      if (this.contactId) {
        this.removeDeliverableContact(this.contactId);
      }
    },

    onShowRemoveSpokesperson(contactId) {
      this.contactId = contactId;
      this.showRemoveSpokesperson = true;
    },
    onConfirmRemoveSpokesperson() {
      if (this.contactId) {
        this.removeDeliverableSpokesperson(this.contactId);
      }
    },

    onShowRemoveWho(contactId) {
      this.contactId = contactId;
      this.showRemoveWho = true;
    },
    onConfirmRemoveWho() {
      if (this.contactId) {
        this.removeDeliverableWho(this.contactId);
      }
    },

    onCloseModal() {
        // update listing with deliverable detail when modal closes
        this.$store.commit(this.namespace + "setDeliverableDetail", this.deliverableDetail);
        this.$store.commit(this.namespace + "setDeliverable", this.deliverableDetail);
        this.$store.commit(this.namespace + "groupUserDeliverable");

      let mId;
      if (this.modalId) {
        mId = this.modalId;
      } else {
        mId = "editSocialModal";
        if (this.namespace == "relatedDeliverables/") {
          mId = "editRelatedSocialModal";
        }
      }
      this.$bvModal.hide(mId);
      this.$nextTick(() => {
        this.$root.$emit('bv::modal::enable-pointer-events');
      });
      if (
        this.$router.currentRoute.name == 'calendar' ||
        this.$router.currentRoute.name == "projectDeliverable"
      ) {
        this.$root.$emit('re__fetch__calendar__data', this.deliverableDetail);
      }
    },

    setTag(newTag) {
      if(!this.userAbilities.editMediaCall || this.deliverableDetail?.permissions?.viewOnly) return;
      this.deliverableDetail.tags.push(newTag);
      this.$store.dispatch(this.namespace + "updateFieldValue", this.deliverableDetail);
    },

    hasContactFields() {
      // let r = _.filter(this.deliverableDetail.customFields, {field_type: 'contacts'});

      // Hardcode for now (filter out contacts field will kill the contact box for other deliverable types as well)
      const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
      return deliverableTemplateSlug == "media-call";
    },

    showDepartment() {
      const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
      return deliverableTemplateSlug == "media-call";
    },

    createTask() {
      this.$refs.TaskFieldLabelsRef.createTask();
    },

    deliverableTitleUpdated(e){
      let that = this;
      if(
        this.title.trim() != this.deliverableDetail.title.trim() &&
        this.title.trim() != "" && 
        !e.target.hasAttribute("disabled")
      ){
        e.target.setAttribute("disabled", true);
        that.$store.dispatch(that.namespace + "updateDeliverableTitle", {
          id: that.deliverableDetail.id,
          title: that.title
        }).then(function(){
          e.target.removeAttribute("disabled");
        });
      }
    },

    deliverableDescriptionUpdated(){
      let that = this;
      if(
        this.description.trim() != this.deliverableDetail.description.trim() &&
        this.description.trim() != "" && 
        !this.descriptionDisabled
      ){
        that.descriptionDisabled = true;
        that.$store.dispatch(that.namespace + "updateDeliverableDescription", {
          id: that.deliverableDetail.id,
          description: that.description
        }).then(function(){
          that.descriptionDisabled = false;
          that.showBriefEditor = false;
        });
      }
    },

    selectedLanguagesUpdated(){
      let that = this;
      if(that.selectedLanguages.length == 0){
        that.selectedLanguages = this.deliverableDetail.languages;
      } else {
        let addLanguages = that.selectedLanguages.filter(x => !that.deliverableDetail.languages.includes(x));
        let removeLanguages = that.deliverableDetail.languages.filter(x => !that.selectedLanguages.includes(x));
        if(addLanguages.length){
          that.languagesDisabled = true;
          that.$store.dispatch(that.namespace + "addDeliverableLanguage", {
            id: that.deliverableDetail.id,
            lang_id: addLanguages[0]
          }).then(function(){
            that.languagesDisabled = false;
          });
        } else if(removeLanguages.length){
          that.languagesDisabled = true;
          that.$store.dispatch(that.namespace + "removeDeliverableLanguage", {
            id: that.deliverableDetail.id,
            lang_id: removeLanguages[0]
          }).then(function(){
            that.languagesDisabled = false;
          });
        } else {
          console.log("Error, no language to add or remove");
        }
      }
    },

    selectedSocialNetworksUpdated(){
      if(this.selectedSocialNetworks.length == 0){
        this.selectedSocialNetworks = this.deliverableDetail.social_networks;
      } else {
        let addSocialNetworks = this.selectedSocialNetworks.filter(x => !this.deliverableDetail.social_networks.includes(x));
        let removeSocialNetworks = this.deliverableDetail.social_networks.filter(x => !this.selectedSocialNetworks.includes(x));
        if(addSocialNetworks.length){
          this.socialNetworksDisabled = true;
          this.$store.dispatch(this.namespace + "addDeliverableSocialNetwork", {
            id: this.deliverableDetail.id,
            social_network_id: addSocialNetworks[0]
          });
        } else if(removeSocialNetworks.length){
          this.socialNetworksDisabled = true;
          this.$store.dispatch(this.namespace + "removeDeliverableSocialNetwork", {
            id: this.deliverableDetail.id,
            social_network_id: removeSocialNetworks[0]
          });
        } else {
          console.log("Error, no social network to add or remove");
        }
      }
    },

    getSocialNetworkSlugFromId(network_id){
      let network = this.systemSettings.social_networks.filter(network => network.id === network_id)[0];
      return network.api_type;
    },
    getSocialNetworkClassFromId(network_id){
      let network = this.systemSettings.social_networks.filter(network => network.id === network_id)[0];
      return this.getSocialNetworkClass(network.api_type);
    },
    getSocialNetworkNameFromId(network_id){
      let network = this.systemSettings.social_networks.filter(network => network.id === network_id)[0];
      return network.network_name;
    },

    isSocialSeriesMaster(id){
      let master_id = this.getSocialSeriesMasterId();
      if(master_id === id){
        return true;
      }
      return false;
    },
    getSocialSeriesMasterId(){
      let series = this.deliverableDetail.social_series_deliverables;
      if (series) {
	      if(series.length){
	        let master = series.find(x => x.is_master === 1);
	        if(master){
	          return master.id;
	        }
	      }
	    }
      return false;
    },
    resetNewDatePicker(){
      //console.log("Try to reset new post datepicker");
    },
    seriesPostClass(post){
      let postDate = this.$moment(post.publish_date).local();
      let today = this.$moment();
      if(postDate.isSame(today, "day")){
        return " today";
      }
      return "";
    },
    createSocialSeriesFromDeliverable(){
      let data = {
        title: this.deliverableDetail.title,
        from_deliverable_id: this.deliverableDetail.id
      }
      this.$store.dispatch(this.namespace + "createSocialSeries", data);
    },
    clickSeriesModalUpdate(){
      let that = this;
      this.seriesManualUpdateDisabled = true;
      this.$store.dispatch(this.namespace + "setAsManuallyUpdated", {
        id: that.deliverableDetail.id
      }).then(function(){
        that.showSeriesManualUpdate = false;
        that.$store.dispatch('manageUndoActivation', 'Editing separately from Master Post');
      });
      this.$store.dispatch('manageUndoActivation', 'Editing separately from Master Post');

    },
    clickSeriesModalCancel(){
      this.showSeriesManualUpdate = false;
      this.$bvModal.hide("editSocialModal");
    },
    clickSeriesModalViewMaster(){
      let that = this;
      
      let masterId = that.getSocialSeriesMasterId();
      this.$store.dispatch(this.namespace + "getDeliverableDetail", {deliverableId: masterId}).then(function(){
      });
    },
    clickSeriesRejoinMaster(){
      this.showSeriesRejoinMaster = true;
    },
    clickCancelRejoinMaster(){
      this.showSeriesRejoinMaster = false;
    },
    clickConfirmRejoinMaster(){
      this.$store.dispatch(this.namespace + "setAsAutomaticallyUpdated", {id: this.deliverableDetail.id}).then(function(){
      });
    },
    clickSeriesAddMultipleDates(){
      this.$bvModal.show("seriesAddMultipleDates");
    },
    seriesModalHidden(event){
      if(event.trigger != null){
        this.$bvModal.hide("editSocialModal");
      }
    },
    displaySeriesPublishDate(seriesPost){
      if(seriesPost){
        let date = this.$moment.utc(seriesPost.publish_date).local().format(this.dateFormat);
        if(date == "Invalid date"){
          return "No date set";
        }
        return date;
      }
    },
    displayPostCommentCount(post){
      let count = post.comments.length;
      let label = "Comments";
      if(count === 1){
        label = "Comment";
      }
      return count + " " + label;
    },
    async initializeSocialModal(){
      await this.getBreadcrumbsInfo();

      this.seriesManualUpdateDisabled = false;
      this.seriesRejoinMasterDisabled = false;
      this.showSeriesManualUpdate = false;
      this.showSeriesRejoinMaster = false;
      if(this.isSocialSeries && 
        !this.isSocialSeriesMaster(this.deliverableDetail.id) && 
        !this.isManuallyUpdated
      ){
      	this.clickSeriesModalViewMaster();
      }
      this.resetNewDatePicker();
      this.showNewDateTime = false;
      if (this.deliverableDetail && this.deliverableDetail.languages) {
      this.selectedLanguages = this.deliverableDetail.languages;
      }
      this.languagesDisabled = false;
      this.socialNetworksDisabled = false;
      if (this.deliverableDetail && this.deliverableDetail.social_networks) {
      this.selectedSocialNetworks = this.deliverableDetail.social_networks;
      }

      if(this.deliverableDetail.title == null){
        this.deliverableDetail.title = "";
      }
      this.title = this.deliverableDetail.title;

      if(this.deliverableDetail.description  == null){
        this.deliverableDetail.description = "";
      }
      this.description = this.deliverableDetail.description;

      
      if(this.isSocialSeries){
        this.$store.dispatch(this.namespace + "getSocialSeriesDetail", {
          seriesId: this.deliverableDetail.social_series[0]
        });
      }
      if(this.isSocialCampaign){
        this.$store.dispatch(this.namespace + "fetchSocialMediaCampaignDetail",
          this.deliverableDetail.social_campaigns[0]
        );
      } else {
        this.$store.commit(this.namespace + "setSocialCampaignDetail", null);
        this.showSocialCampaignSettings = false;
      }

      this.overlayListener();

    },

    escapeListener(e){

    	// don't close if escaping from file pond upload file dialog.
    	if (
    	 (e.target.tagName != "INPUT" || e.target.id.indexOf("filepond") == -1)
    	 ) {
      	 this.onCloseModal();
    	}

    },

    overlayListener(){
      if(!this.contentDiv){
        return;
      }

      let olTop = this.$refs.overlayTop;
      let olRight = this.$refs.overlayRight;
      let olBottom = this.$refs.overlayBottom;
      let olLeft = this.$refs.overlayLeft;

      if(!olTop || !olRight || !olBottom || !olLeft){
        return;        
      }

      let header = document.querySelector("#header__controls__osmp");
      let activeRow = document.querySelector(".deliverable-listing.social-media .row.active");
      let planModalRow = document.querySelector(".related-deliverable-block-wrap .row.active");
      if (planModalRow) {
        activeRow = planModalRow;
      }

      let contentRect = this.contentDiv.getBoundingClientRect();
      let contentWidth = this.contentDiv.clientWidth + 150;
      let contentHeight = this.contentDiv.clientHeight;

      let contentLeft = contentRect.left;

      let sidebarRect = document.querySelector("#sidebar").getBoundingClientRect();
      let sidebarWidth = sidebarRect.width;

      if(activeRow && header){
        let rowRect = activeRow.getBoundingClientRect();
        let headerRect = header.getBoundingClientRect();
        if(olTop){

          olTop.style.top = 0;
          olTop.style.left = (contentLeft - sidebarWidth) + "px";
          olTop.style.width = (contentWidth + sidebarWidth) + "px";
          olTop.style.height = rowRect.top + "px";
          if(rowRect.bottom <= headerRect.bottom){
            olTop.style.height = 0;
          } else if (rowRect.top >= contentHeight){
            olTop.style.height = contentHeight + "px";
          } else if (rowRect.top <= headerRect.height){
            olTop.style.height = headerRect.height + "px";
          }
        }


        if(olBottom){
        	let x = 0;
          olBottom.style.top = rowRect.bottom + "px";
          olBottom.style.left = (contentLeft- sidebarWidth)+ "px";
          olBottom.style.width = (contentWidth+ sidebarWidth) + "px";
        	let h = (contentHeight - rowRect.bottom);
        	if (h > 0) {
          	olBottom.style.height = h + "px";
          }
          if(contentHeight - rowRect.bottom <= 0){
            olBottom.style.height = 0;
          } else if(rowRect.bottom <= headerRect.bottom){
            olBottom.style.height = contentHeight + "px";
            olBottom.style.top = 0;
          } else if (rowRect.top > 0 && rowRect.bottom <= headerRect.bottom){
            //olBottom.style.height = 
          }
        }
        if(olLeft){
          olLeft.style.left = (contentLeft- sidebarWidth) + "px";
          let w = (rowRect.left);
          if (w > 0) {
          	olLeft.style.width = w + "px";
          }


          if(w <= 0){
            olLeft.style.width = 0;
          }

          olLeft.style.top = rowRect.top + "px";
          olLeft.style.height = rowRect.height + "px"
          if(rowRect.top >= contentHeight){
            olLeft.style.height = 0;
          } else if(rowRect.bottom <= headerRect.bottom){
            olLeft.style.height = 0;
          } else if(rowRect.top <= headerRect.bottom){
            olLeft.style.height = (rowRect.bottom - headerRect.bottom) + "px";
            olLeft.style.top = headerRect.bottom + "px";
          } else if(rowRect.bottom >= contentHeight){
            olLeft.style.height = (contentHeight - rowRect.top) + "px";
          }
        }


        if(olRight){
          olRight.style.left = rowRect.right + "px";

          let w = (contentLeft + contentWidth - rowRect.right)
          if (w > 0) {
          	olRight.style.width = w + "px";
          }

          if(contentLeft + contentRect.width - rowRect.right <= 0){
            olRight.style.width = 0;
          }
          olRight.style.top = rowRect.top + "px";
          olRight.style.height = rowRect.height + "px"
          if(rowRect.top >= contentHeight){
            olRight.style.height = 0;
          } else if(rowRect.bottom <= headerRect.bottom){
            olRight.style.height = 0;
          } else if(rowRect.top <= headerRect.bottom){
            olRight.style.height = (rowRect.bottom - headerRect.bottom) + "px";
            olRight.style.top = headerRect.bottom + "px";
          } else if(rowRect.bottom >= contentHeight){
            olRight.style.height = (contentHeight - rowRect.top) + "px";
          }
        }
      } else {
        if(olTop){
          olTop.style.top = contentRect.top + "px";
          olTop.style.left = contentLeft + "px";
          olTop.style.width = contentWidth + "px";
          if(contentWidth <= 0){
            olTop.style.width = 0;
          }
          olTop.style.height = contentHeight + "px";
          if(contentHeight <= 0){
            olTop.style.height = 0;
          }
        }
        
        if(olBottom){
          olBottom.style.width = 0;
          olBottom.style.height = 0;
        }
        
        if(olLeft){
          olLeft.style.width = 0;
          olLeft.style.height = 0;
        }

        if(olRight){
          olRight.style.width = 0;
          olRight.style.height = 0;
        }
      }
    },
    updateTabIndex(){
     this.currentTab = this.tabIndex;
    },

    formatCaptionText(text) {
    	return Autolinker.link(text);
    },

    updateDeliverableTasks() {
      /*
      * update my-week listing task statuses 
      * when post content/schedule is approved/rejected 
      * from edit social media post modal (Tab 3 Summary)
      */
      // this.$store.dispatch(this.namespace + "updateFieldValue", this.deliverableDetail);
    },

    async getBreadcrumbsInfo() {
      await this.$store.dispatch(this.namespace + 'fetchDeliverableBreadcrumbs', {
        parentDeliverableId: this.deliverableDetail.parent_deliverable_id,
        deliverableId: this.deliverableDetail.deliverableId,
      });
    },

    async copyFn(valueToCopy, post_id) {
      clearTimeout(this.copySuccessTimeout);
      try {
        const navPer = await navigator.permissions.query({ name: "clipboard-write" });
        if (navPer.state == "granted" || navPer.state == "prompt") {
          try {
            await navigator.clipboard.writeText(valueToCopy);
          } catch {
            console.error("clipboard API error. Cannot copy to clipboard.");
          }
        } else {
          console.log("clipboard API error. Cannot copy to clipboard.");
        }
      } catch {
        try {
          await navigator.clipboard.writeText(valueToCopy);
        } catch {
          console.error("clipboard API error. Cannot copy to clipboard.");
        }
      }
      // Update the icon and tooltip text
      this.$set(this.copyStates, post_id, {
        icon: 'fas fa-check',
        tooltip: 'Copied!'
      });

      // Reset the icon and tooltip text after 2 seconds
      this.copySuccessTimeout = setTimeout(() => {
        this.$set(this.copyStates, post_id, {
          icon: 'far fa-copy',
          tooltip: 'Copy Post Copy'
        });
      }, 2000);
    },
    getCopyIconClass(post_id) {
      return this.copyStates[post_id]?.icon || 'far fa-copy';
    },
    getCopyTooltipText(post_id) {
      return this.copyStates[post_id]?.tooltip || 'Copy Post Copy';
    },
    async downloadImagesZip() {
      await this.$store.dispatch(this.namespace + 'downloadSocialPostsFiles', {
        deliverableId: this.deliverableDetail.deliverableId,
      });
    },
  },
  watch: {
    deliverableDetail(newDetail, oldDetail) {
      this.initializeSocialModal();
      if (newDetail.id !== oldDetail.id) {
        this.$emit("modalDetailUpdated");
        if (this.deliverableDetail.title == "Enter Post Name") {
          // focus the post name so they give it a name.
          // activateTitleField wont be called now 
          // since posts' title is "Plan title + incrementing integer"
          setTimeout(() => {
            this.activateTitleField();
          }, 500);
        }
      }
    },
    tabIndex(){
      this.updateTabIndex();
    },
  },
  created(){
    this.initializeSocialModal();
    this.fetchUserManageSocialCampaigns();
    this.fetchSocialCampaigns();

    // Listen for events to reapply overlay positions
    this.contentDiv = document.querySelector("#content");
    this.contentDiv.addEventListener('scroll', this.overlayListener);
    window.addEventListener('resize', this.overlayListener);
    
    let resize = new ResizeObserver(entries => {
      this.overlayListener();
    });
    resize.observe(document.querySelector("#sidebar"));
    resize.observe(this.contentDiv);
    this.overlayInterval = setInterval(() => {
      this.overlayListener();
    }, 200);
  },
  mounted() {



    $('#editSocialModal .modal-content').removeAttr('tabindex');
    $('#editRelatedSocialModal .modal-content').removeAttr('tabindex');
    if (this.userAbilities && this.deliverableDetail?.permissions) {
	    if(!this.userAbilities.editMediaCall || this.deliverableDetail?.permissions?.viewOnly) {
	      $('.add-contact-button, .add-resource-button').removeAttr('title').attr('disabled', 'disabled');
	    }
	  }
    this.carouselInterval = 0;

    this.overlayListener();
    let that = this;
    document.body.onclick = function(e) {
      if(e.target.id === "editSocialModal___BV_modal_backdrop_"){
        that.onCloseModal();
      }
      if(e.target.id === "editRelatedSocialModal___BV_modal_backdrop_"){
        that.onCloseModal();
      }
    };
    this.$nextTick(function(){
      this.updateTabIndex();
      setTimeout(function() {
      	that.$refs.rootTag.focus();
      	if (that.openWithFocus != null) {
      		if ($(that.openWithFocus).length > 0) {
      			if (that.tabIndex == 0) {
      				if (that.openWithFocus == ".below-tasks") {
	      				that.$refs.refBelowTasks.scrollIntoView({ behavior: "smooth" });
      				} else if (that.openWithFocus == ".nav-item.tabCommentsTitle")  {
      					that.currentTab = 1;
      				} else {
	      				$(that.openWithFocus)[0].focus();
	      				that.$refs.refPostEditor.scrollIntoView({ behavior: "smooth" });
	      			}
	      		}
      			that.setOpenWithFocus(null);
      		}
      	} else {
      			if (that.deliverableDetail.title == "Enter Post Name") {
      					// focus the post name so they give it a name.
      					that.activateTitleField();
      			}
      	}
      }, 200);
      setTimeout(function () {
        if (that.deliverableDetail.deliverableId !== undefined) {
          // call api to read all alerts after 10 seconds
          that.$store.dispatch(
            'makeAllRelatedAlertRead',
            {
              groupedModelId: that.deliverableDetail.deliverableId
            }
          );
        }
      }, 10000);
    });
  },
  beforeDestroy() {
    this.$root.$emit('postModalClose');
  },
  destroyed(){
    // Remove listener once modal is destroyed
    window.removeEventListener('keyup', this.escapeListener);
    window.removeEventListener('resize', this.overlayListener);
    if (this.contentDiv) {
	    this.contentDiv.removeEventListener('scroll', this.overlayListener);
	  }
    document.body.classList.remove("social-modal-open");
    clearInterval(this.overlayInterval);
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.disabled {
  cursor: not-allowed;
  opacity: 0.9;
  pointer-events: none;
}
.btn-create-series {
  pointer-events: all;
}
.social-settings-row h3 {
  font-size: 1rem;
  display: inline-block;
  margin-bottom: 0px;
	vertical-align: middle;
	min-height: 25px;
	margin-right: 10px;
	font-weight: 600;
	text-transform:uppercase;
}

.social-settings-row .social-settings-group {
	display:inline-block;
}



.details.post-editor {
	margin-bottom:0px;
}


section.settings .settings-header {
	margin-left:-20px;
}

.settings.campaign-settings {
	padding:20px 25px 25px 25px;
}
.settings.series-settings {
	padding:10px 25px 25px 25px;
	background:var(--wf-secondary-tertiary-mix93);
}

.settings.tag-settings {
	padding:10px 25px;
}

.type-label {
	color: var(--wf-primary);
display:block;
font-weight: 400;
font-size: 1em;
text-transform:uppercase;
}
.group-title {
	font-size:22px;
}
.group-title h1 {
	font-size:22px;
}
.group-title-wrapper {
	width:100%;
	}
.posting-dates-title {
	font-size:1rem;
	text-transform:uppercase;
	font-weight:600;
}
.details.brief-editor {
	margin-bottom:0px !important;
}

.brief-editor h3 {
	font-size:1.2rem;
	text-transform:uppercase;
	font-weight:600;
}

.summary-download-images-link {
  text-transform: uppercase;
  color: var(--wf-primary);
}
</style>
